/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react';
import Correct from './Group 980.svg';
import Wrong from './Group 981.svg'

const QuizSingleSelect = props => {
    const data = props.data;

    //int representing current selected option index
    const [selected, setSelected] = useState(-1);

    //feedback is obj representing current feedback text, gotten from data.options.feedback
    //null means no current feedback
    const [feedback, setFeedback] = useState(null);


    const handleOptionClick = (optionIndex) => {
            setSelected(optionIndex)
            if(props.setCurrentChoice) props.setCurrentChoice(optionIndex);
            if(props.handelClick) props.handelClick(optionIndex);
    }

    const handleCloseFeedback = () => {
        if(data.options[selected].correct){
            //correct
            props.onComplete("");
        }else{
            //incorrect
            setSelected(-1)
        }
    }

    useEffect(()=>{
        console.log('selected changed', selected);
        if(data.options[selected]){
            setFeedback(data.options[selected].feedback)
        }else{
            setFeedback(null)
        }
    }, [selected])

    useEffect(()=>{
        setSelected(props.currentChoice)
    },[props.currentChoice])


    return (
        <div className="QuizSingleSelect">
            {/* <div className={`debug`}>
                Current: {selected}
            </div> */}
            {data.header && <div className={`header`} dangerouslySetInnerHTML={{__html:data.header}}></div>}
            {data.questionText && <div className={`question-text`} dangerouslySetInnerHTML={{__html:data.questionText}}></div>}

            <div className={`options`}>
                {
                    data.options.map((option, optionIndex) => {
                        return (
                        <div className="option-container">
                            <div key={`option-${optionIndex}`} className={`question-option ${selected === optionIndex ? 'selected' : "not-selected"}`} onClick={()=>handleOptionClick(optionIndex)}>                            
                                {option.text}
                            </div>
                            <div className="icon-img">
                                {props.total[optionIndex] !== null &&
                                    <>
                                    {props.total[optionIndex]?
                                        <img src={Correct} alt={'Correct Icon'} />
                                        :
                                        <img src={Wrong} alt={"Wrong Icon"} />
                                    }
                                    </>
                                }
                            </div>
                        </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default QuizSingleSelect;

 // {
    //     questionText:"what is the answer?",
    //     options:[
    //         {
    //             "text":"whatever answer text",
    //             "correct":false,
    //             "feedback":{
    //                 "header":"header",
    //                 "class":"correct",
    //                 button:"OK",
    //                 "body":"whatever body html"
    //             }
    //         },
    //         {
    //             "text":"whatever answer text2",
    //             "correct":true,
    //             "feedback":{
    //                 "header":"header",
    //                 "class":"correct",
    //                 button:"OK",
    //                 "body":"whatever body html"
    //             }
    //         },
    //         {
    //             "text":"whatever answer text3",
    //             "correct":false,
    //             "feedback":{
    //                 "header":"header",
    //                 "class":"correct",
    //                 button:"OK",
    //                 "body":"whatever body html"
    //             }
    //         }
    //     ]
    // }